export default function getDevice():number{
    let tipoDispositivo:number
    
    if(/Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        tipoDispositivo = 3;
    }else if(/iPad|iPod/i.test(navigator.userAgent)){
        tipoDispositivo = 4;
    }else{
        tipoDispositivo = 2;
    }

    return tipoDispositivo
}